import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPhone, FaRupeeSign, FaCheckCircle, FaTimesCircle, FaSpinner } from 'react-icons/fa';
import axios from 'axios';
import toast from 'react-hot-toast';
import PhonePePayment from './PhonePePayment';
import PaymentLoader from './PaymentLoader';
import PaymentReceipt from './PaymentReceipt';

const PaymentGateway = ({ amount, feeId, studentId, feeMonth, onSuccess }) => {
  const [showPayment, setShowPayment] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showReceipt, setShowReceipt] = useState(false);
  const [loaderStatus, setLoaderStatus] = useState('processing');
  const [paymentData, setPaymentData] = useState(null);
  const navigate = useNavigate();

  const handlePaymentSuccess = (data) => {
    setShowLoader(true);
    setLoaderStatus('processing');
    
    // Simulate payment processing
    setTimeout(() => {
      setLoaderStatus('verifying');
      setTimeout(() => {
        setLoaderStatus('success');
        
        // Create payment receipt data
        const receiptData = {
          receiptId: 'RCP-' + Date.now().toString().slice(-8),
          studentName: localStorage.getItem('studentName') || 'Student User',
          studentId: studentId || localStorage.getItem('studentId') || 'STU1001',
          feeMonth: feeMonth || 'Monthly Fee',
          amount: amount,
          paymentMethod: 'PhonePe UPI',
          status: 'Paid',
          date: new Date().toISOString(),
          transactionId: 'TXN-' + Date.now().toString().slice(-10)
        };
        setPaymentData(receiptData);
        
        setTimeout(() => {
          setShowLoader(false);
          setShowPayment(false);
          setShowReceipt(true);
          toast.success('Payment successful! 🎉');
          if (onSuccess) onSuccess();
        }, 1500);
      }, 2000);
    }, 2000);
  };

  const handlePaymentCancel = () => {
    setShowPayment(false);
    toast.info('Payment cancelled');
  };

  const handleReceiptClose = () => {
    setShowReceipt(false);
    navigate('/student/fees');
  };

  return (
    <>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setShowPayment(true)}
        className="px-6 py-3 rounded-xl text-white font-semibold transition-all duration-300 bg-gradient-to-r from-purple-600 to-blue-500 hover:shadow-lg flex items-center gap-3"
      >
        <FaPhone className="text-lg" />
        Pay with PhonePe
      </motion.button>

      {/* Payment Modal */}
      <AnimatePresence>
        {showPayment && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
            onClick={(e) => {
              if (e.target === e.currentTarget) setShowPayment(false);
            }}
          >
            <PhonePePayment
              amount={amount}
              feeId={feeId}
              studentId={studentId}
              feeMonth={feeMonth}
              onSuccess={handlePaymentSuccess}
              onCancel={handlePaymentCancel}
            />
          </motion.div>
        )}
      </AnimatePresence>

      {/* Payment Loader */}
      <AnimatePresence>
        {showLoader && (
          <PaymentLoader status={loaderStatus} amount={amount} />
        )}
      </AnimatePresence>

      {/* Payment Receipt */}
      <AnimatePresence>
        {showReceipt && (
          <PaymentReceipt 
            payment={paymentData} 
            onClose={handleReceiptClose} 
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default PaymentGateway;
